import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface CuocDieuTra {
  name: string;
  api_token: string;
}

export interface cheDoBaoCaoDetaiInfor {
  errors: unknown;
  CuocDieuTra: CuocDieuTra;
  isAuthenticated: boolean;
}

@Module
export default class CuocDieuTraDetailModule
  extends VuexModule
  implements cheDoBaoCaoDetaiInfor
{
  errors = {};
  CuocDieuTra = {} as CuocDieuTra;
  isAuthenticated = !!JwtService.getToken();
  cuocDieuTraDetailData = {} as any;

  /**
   * Get current user object
   * @returns User
   */
  get cuocDieuTraDetail() {
    return this.cuocDieuTraDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.SET_CUOC_DIEU_TRA_DETAIL](CuocDieuTra) {
    this.cuocDieuTraDetailData = CuocDieuTra;
  }
  @Action
  [Actions.FETCH_CUOC_DIEU_TRA_DETAIL](payload) {
    return ApiService.getDataDetail("/cuocdieutras", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_CUOC_DIEU_TRA_DETAIL, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
